export default "__VITE_ASSET__bb11657a__"